import axios from "axios";
import { retrieveToken } from "./utils/localStorage";
const hostname = window.location.hostname;
// console.log('hostname',hostname)

axios.defaults.headers.post["Content-Type"] = "application/json";

axios.defaults.headers["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers["Access-Control-Allow-Credentials"] = true;

let localBool = hostname.indexOf("localhost") > -1 || hostname.indexOf("ngrok") > -1;
let devBool = hostname.indexOf("devportal") > -1  || hostname.indexOf("trivvy") > -1 ;
let qaBool = hostname.indexOf("qaportal") > -1 

let local;
if (localBool) {
  local = `${window.location.protocol}//localhost:8090`;
  // local = `${window.location.protocol}//devapi.ouroffice.io`;
} else if (devBool) {
  local = `${window.location.protocol}//devapi.ouroffice.io`;
} else if (qaBool) {
  local = `${window.location.protocol}//qaapi.ouroffice.io`;
} else {
  local = `${window.location.protocol}//api.ouroffice.io`;
}
// local = `${window.location.protocol}//api.ouroffice.io`;
console.log(local)
const instance = axios.create({
  // baseURL: `${window.location.protocol}//devapi.ouroffice.io`,
  // baseURL: ENV === PROD ? `${window.location.protocol}//api.ouroffice.io` :
  //     ENV === QA ? local :
  //     ENV === DEV ? `${window.location.protocol}//devapi.ouroffice.io`: null
  // for dev : 'https://devapi.ouroffice.io'
  baseURL: local,
  // `${window.location.protocol}//devapi.ouroffice.io`:
  // baseURL: `${window.location.protocol}//portalapi.ouroffice.io`,
  // baseURL: `${window.location.protocol}//localhost:8090`
});

// console.log('inst - ',instance.baseURL)

instance.all = axios.all;
instance.spread = axios.spread;

// instance.defaults.headers.common['Authorization'] = `Bearer ${retrieveToken()}`;
instance.interceptors.request.use(config => {
  const token = `Bearer ${retrieveToken()}`;
  config.headers.Authorization = token;
  config.headers.Pragma = "no-cache";
  config.headers["Access-Control-Allow-Origin"] = "*";
  config.headers["Access-Control-Allow-Credentials"] = true;
  return config;
});

export default instance;
